<script setup lang="ts">
const props = defineProps<{
  name: string
  id: number| null
}>()
</script>
<template>
  <router-link
    :to="{name: name, params: {id: id}}"
    class="d-flex material-symbols-outlined edit-icon"
  >
    edit_note
  </router-link>
</template>     
<style scoped>
.edit-icon {
  color: black;
  text-decoration: none;
}
.edit-icon:hover {
  color: black;
  cursor: pointer;
  opacity: 0.5;
}
.edit-icon:focus {
  color: black;
}
</style>